import React from 'react';
import _ from 'lodash';
import SimpleShared from 'go/components/modules/requestDetails/v3/items/shared/SimpleShared';
import {ADDITIONAL_INFORMATION, COST} from 'common/requestDetails/constants';
import {produceAppliedDiff} from 'framework/collaboration/diff.utils';

export default class Simple extends React.Component {
  state = {
    lineItem: this.props.item,
  };

  handleChange = (lineItem, prevPropsItem, currentlyCollaborating) => {
    return new Promise((resolve) => {
      if (currentlyCollaborating) {
        if (!_.isEqual(prevPropsItem, lineItem)) {
          this.setState(
            (prevState) => ({
              lineItem: produceAppliedDiff(prevPropsItem, lineItem, prevState?.lineItem),
            }),
            () => resolve()
          );
        }
      } else {
        this.setState({lineItem}, () => resolve());
      }
    });
  };

  handleBlur = (fieldName) => {
    if (this.props.editable) {
      let {lineItem} = this.state;
      let {item} = this.props;
      lineItem = _.cloneDeep(lineItem);
      let itemToDisplay = {
        ...lineItem,
        [ADDITIONAL_INFORMATION]: {
          ..._.get(item, ADDITIONAL_INFORMATION), // need to bring in additional information saved outside this component
          ..._.get(lineItem, ADDITIONAL_INFORMATION),
        },
      };

      this.setState((prevState) => ({
        lineItem: {
          ...prevState.lineItem,
          bocTotals: itemToDisplay.bocTotals,
        },
      }));
      this.props.saveItem(this.props.sourcePath, itemToDisplay, fieldName);
    }
  };

  handleItemChange = (name, value, ind = -1, extraArgs) => {
    const {item, itemConfig} = this.props;
    const bundledCostValues = _.get(itemConfig, 'bundledCostValues');
    let attributeName = _.split(name, '.').pop();
    if (_.includes(bundledCostValues, attributeName)) {
      return this.handleBundledItemChange(attributeName, value);
    } else {
      let newLineItem = _.cloneDeep(item);
      _.set(newLineItem, name, value);
      if (_.get(extraArgs, 'resetFields')) {
        _.each(extraArgs.resetFields, (field) => {
          _.unset(newLineItem, field);
        });
      }
      return this.handleChange(newLineItem);
    }
  };

  handleBundledItemChange = (attributeName, value, ind = -1) => {
    let newLineItem = _.cloneDeep(this.props.item);
    let costs = _.get(newLineItem, COST);
    _.map(costs, (costArray) => {
      if (ind !== -1) {
        _.set(costArray[ind], attributeName, value);
      } else {
        _.map(costArray, (cost) => {
          _.set(cost, attributeName, value);
        });
      }
    });
    return this.handleChange(newLineItem);
  };

  handleItemChangeAndBlur = (name, value, fieldName) => {
    this.handleItemChange(name, value).then((res) => {
      this.handleBlur(fieldName);
    });
  };

  render() {
    return (
      <SimpleShared
        lineItem={this.state.lineItem}
        handleChange={this.handleChange}
        handleBlur={this.handleBlur}
        handleItemChange={this.handleItemChange}
        handleItemChangeAndBlur={this.handleItemChangeAndBlur}
        {...this.props}
      />
    );
  }
}
